import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const CollapsibleSection = ({
  title,
  children,
  isCollapsed = false,
  defaultExpanded = true,
  sectionKey,
}) => {
  const getInitialState = () => {
    try {
      const savedState = localStorage.getItem(`sidebar-section-${sectionKey}`);
      if (savedState !== null) {
        const parsed = JSON.parse(savedState);
        return parsed;
      }
    } catch (error) {
      console.error(`Error loading ${sectionKey} from localStorage:`, error);
    }
    return defaultExpanded;
  };

  const [isExpanded, setIsExpanded] = useState(getInitialState);

  useEffect(() => {
    try {
      localStorage.setItem(
        `sidebar-section-${sectionKey}`,
        JSON.stringify(isExpanded)
      );
    } catch (error) {
      console.error(`Error saving ${sectionKey} to localStorage:`, error);
    }
  }, [isExpanded, sectionKey]);

  const shouldShowContent = isExpanded;
  const toggleSection = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="collapsible-section" key={sectionKey}>
      <div
        className={`section-header ${isCollapsed ? "collapsed" : ""}`}
        onClick={toggleSection}
      >
        <h3 className={isCollapsed ? "hidden" : ""}>
          {title}
        </h3>
        {!isCollapsed && (
          <FontAwesomeIcon
            icon={isExpanded ? faChevronUp : faChevronDown}
            className="section-toggle-icon"
          />
        )}
      </div>
      <div
        className={`section-content ${
          shouldShowContent ? "expanded" : "collapsed"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default CollapsibleSection;
